__turbopack_context__.v({
  "description": "style-module-scss-module__1fIM3a__description",
  "descriptionYear": "style-module-scss-module__1fIM3a__descriptionYear",
  "segment": "style-module-scss-module__1fIM3a__segment",
  "title": "style-module-scss-module__1fIM3a__title",
  "video": "style-module-scss-module__1fIM3a__video",
});
